<template>
    <div>
        <el-container>
            <div class="content">
                <el-main class="main">
                    <div class="header">
                        <h2>{{detail.situation}}</h2>
                        <p>
                            <span>类别：{{detail.type}}</span>
                            <span>学历/学位：{{detail.degree}}</span>
                            <span>招聘人数：{{detail.number}}人</span>
                            <span>发布日期：{{detail.updateTime}}</span>
                            <span>工作地点：{{detail.address}}</span>
                        </p>
                    </div>

                   <div class="part">
                        <h2>专业要求</h2>
                        <p style="white-space: pre-line;">{{ detail.jobRequirements }}</p>

                    </div>
                    <div class="part">
                        <h2>基本要求</h2>
                        <p style="white-space: pre-line;">{{ detail.colligateRequirements }}</p>
                    </div>

<!--                   <div class="part">-->
<!--                        <h2>优先条件</h2>-->
<!--                        <p style="white-space: pre-line;">{{ detail.priorCondition }}</p>-->
<!--                    </div>-->

                    <div class="part">
                        <h2>招聘流程</h2>
                        <p style="white-space: pre-line;">{{ detail.recruit }}</p>
                    </div>

                    <div class="contact">
                        <h2>联系方式</h2>
                        <p style="white-space: pre-line;">{{ detail.contactWay }}</p>
                    </div>
                    <div class="footer">
                        <el-button type="primary" round @click="applyFor">立即申请</el-button>
                        <el-button round @click="goback">返回</el-button>
                    </div>
                </el-main>
            </div>
        </el-container>
        <Footer/>
    </div>
</template>

<script>

    import Header from '../base/Header'
    import Footer from '../base/Footer'

    import {getRecruitDetail} from '../api'

    export default {
        name: 'Detail',
        props: {
            msg: String
        },
        components: {Header, Footer},
        data() {
            return {
                date2: '',
                detail: {
                    situation: '',
                    type: '',
                    degree: '',
                    number: 0,
                    releaseTime: '',
                    jobRequirements: '',
                    colligateRequirements: '',
                    priorCondition: '',
                    recruit: '',
                    contactWay: '',
                },
            }
        },
        methods: {
            applyFor() {
                this.$router.push('/resume')
            },
            goback() {
                this.$router.go(-1);
            },

            async getDetail() {
                this.detail = await getRecruitDetail(this.$route.params.id).then(res => {
                    return res.content;
                });
            }
        },
        created() {
            this.getDetail()
        }
    }
</script>

<style scoped lang="less">
    .content {
        margin: 0 auto;
        width: 1000px;
        padding: 20px 0;
        .main {
            margin: 60px auto 0;
            background: #FFF;
            text-align: left;
            padding: 20px 40px;
            div {
                margin-bottom: 30px;
                h2 {
                    font-size: 20px;
                    color: red;
                    height: 30px;
                    line-height: 30px;
                    margin: 10px 0;
                }
                p {
                    line-height: 26px;
                }
            }
            .header {
                text-align: left;
                border-bottom: 1px solid #CCC;
                height: 100px !important;
                h2 {
                    font-size: 24px;
                    font-weight: 600;
                    margin: 20px 0;
                    color: #333;
                }
                p {
                    color: #909090;
                    span {
                        margin-right: 40px;
                    }
                }
            }
            .deadline {
                color: red;
            }
            .footer {
                text-align: center;
                button {
                    width: 120px;
                }
            }
        }
    }
</style>
